/* eslint-disable @next/next/no-img-element */
import { useRouter } from "next/router";
import { useTranslation } from "react-i18next";
import Argument from "@buddieshr/components/templates/argument";
import Footer from "@buddieshr/components/footer";
import Header from "@buddieshr/components/header";
import MetaHeader from "@buddieshr/components/metaHeader";
import styles from "@buddieshr/styles/Home_Billy.module.scss";
import PageWrapper from "@buddieshr/components/templates/pageWrapper";
import StopProcrastinating from "@buddieshr/components/landing/stopProcrastinating";
import { Button } from "antd";
import Link from "next/link";

export default function HR(pageProps) {
  const router = useRouter();
  const { t } = useTranslation();

  return (
    <>
      <MetaHeader
        title={t("titleHR")}
        description={t("descriptionHR")}
        currentURL={`https://buddieshr.com/${
          router.locale === "en" ? "" : router.locale
        }/use-cases/human-resources`}
        currentShare={`https://buddieshr.com/img/share_preview_1.png`}
        pageSlug={`use-cases/human-resources`}
        locale={router.locale}
      />
      <Header />
      <div className={styles.container}>
        <main className={styles.main} style={{ paddingTop: 0 }}>
          <div>
            <div className={styles.HR_inner}>
              <div
                className={styles.Page_header_wrapper}
                style={{ background: "none" }}
              >
                <h1 className={styles.bold} style={{ color: "#1f3a45" }}>
                  {t("titleForHR")}
                </h1>
                <div
                  className={styles.Page_header_description}
                  style={{ color: "#1f3a45" }}
                >
                  {t("descriptionHR")}
                </div>

                <Link href="/get-started">
                  <Button
                    // icon={<CaretRightOutlined />}
                    type="primary"
                    size="large"
                    style={{ minWidth: 230, marginTop: "18px" }}
                  >
                    Get started
                  </Button>
                </Link>
              </div>

              <div className={styles.HRQuote}>{t("hrQuote")}</div>
              {/* Arguments */}
              <PageWrapper>
                <div className={styles.Arguments_list}>
                  <Argument
                    title={t("arg3Title")}
                    description={t("recognitionCultureDesc")}
                    pictureUrl={"/img/Winners_Two Color.png"}
                    reverse
                  />
                  <Argument
                    title={t("arg2Title")}
                    description={t("benefits3_desc")}
                    pictureUrl={"/img/Video call_Outline.png"}
                    showCTA
                  />
                  <Argument
                    title={t("arg1Title")}
                    description={t("benefits2_desc")}
                    pictureUrl={"/img/Team work_Outline.png"}
                    reverse
                  />
                  <Argument
                    title={t("arg4Title")}
                    description={t("benefits4_desc")}
                    pictureUrl={"/img/Smiley face_Outline.png"}
                  />
                </div>
              </PageWrapper>

              <StopProcrastinating />
            </div>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}
